import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ManufacturingOrder } from '../../../../core/models/manufacturing-order';
import { AbstractEditionModalForm } from '../edition-modal/abstract-edition-modal-form';

@Component({
  selector: 'app-manufacturing-order-observations-form',
  templateUrl: './manufacturing-order-observations-form.component.html',
  styleUrls: ['./manufacturing-order-observations-form.component.css'],
  providers:
    [{ provide: AbstractEditionModalForm, useExisting: forwardRef(() => ManufacturingOrderObservationsFormComponent) }]
})
export class ManufacturingOrderObservationsFormComponent
  extends AbstractEditionModalForm<ManufacturingOrder> implements OnInit {
  form: AbstractControl;
  // Observations are optional: an empty value clears the planner note.
  @Input() manufacturingOrder: ManufacturingOrder;
  // i18n key of the textarea label; callers outside the planner can override it.
  @Input() labelKey = 'dashboard.scheduler.table.editObservations.form.observations';

  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      observations: [
        this.manufacturingOrder ? this.manufacturingOrder.plannerObservations : '',
        [Validators.maxLength(2000)]
      ]
    });
  }

  updateForm(model?: ManufacturingOrder, _params?: any) {
    // The modal opens without a model, so fall back to the OF passed as @Input,
    // pre-filling the textarea with the current planner observation (if any).
    const order = model || this.manufacturingOrder;
    const value = {
      observations: order ? order.plannerObservations : ''
    };
    this.form.reset(value);
  }

  getFormData() {
    const formValue = this.form.value;
    return {
      observations: formValue.observations
    };
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/manufacturing-order-observations-form/manufacturing-order-observations-form.component.ts